module.exports = __webpack_public_path__ + "static/media/licenta25.833c1405.png";